import { useEffect, useState } from 'react';
import { ERROR_PAGE_FILES } from '../constants';
import type { ErrorPageKind } from '../types';

interface Props {
  kind: ErrorPageKind;
  onRetry: () => void;
}

const FALLBACK = `<!doctype html><html><body style="margin:0;min-height:100vh;display:grid;place-items:center;background:#eef8fa;color:#434242;font-family:'Roboto Slab',Georgia,serif"><main style="width:min(520px,calc(100% - 32px));text-align:center;background:#fff;border:1px solid rgba(67,66,66,.16);border-radius:28px;padding:36px;box-shadow:0 24px 70px rgba(67,66,66,.12)"><svg width="96" height="96" viewBox="0 0 512 512" aria-hidden="true"><circle cx="256" cy="256" r="236" fill="#fff" stroke="#57a7b3" stroke-width="18"/><path d="M235 394c-44-76-48-193 0-276 12-20 31-20 43 0 49 83 45 200 0 276-6 11-68 11-43 0z" fill="#434242"/><path d="M151 290c-37-82 21-157 103-145-66 15-107 73-94 133 8-31 32-51 63-55-25 24-18 62 13 72-47 29-78 26-85-5zM361 290c37-82-21-157-103-145 66 15 107 73 94 133-8-31-32-51-63-55 25 24 18 62-13 72 47 29 78 26 85-5z" fill="#57a7b3"/></svg><h1>WebSurf error</h1><p>The custom error page could not be loaded.</p><button style="border:0;border-radius:999px;padding:12px 22px;background:#434242;color:white;font:inherit;font-weight:700" onclick="parent.postMessage({type:'retry'},'*')">Retry</button></main></body></html>`;

export function ErrorDocumentFrame({ kind, onRetry }: Props) {
  const [html, setHtml] = useState(FALLBACK);

  useEffect(() => {
    let cancelled = false;
    fetch(ERROR_PAGE_FILES[kind] || ERROR_PAGE_FILES.error)
      .then((response) => response.ok ? response.text() : FALLBACK)
      .then((text) => { if (!cancelled) setHtml(text); })
      .catch(() => { if (!cancelled) setHtml(FALLBACK); });
    return () => { cancelled = true; };
  }, [kind]);

  useEffect(() => {
    function handler(event: MessageEvent) {
      if (event.data?.type === 'retry') onRetry();
      if (event.data?.type === 'websurf:home') window.parent?.postMessage?.({ type: 'websurf:home' }, '*');
    }
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [onRetry]);

  return <iframe title={`${kind} page`} className="browser-frame error-frame" srcDoc={html} sandbox="allow-scripts" />;
}
